import React, { useContext, useState, useEffect } from "react";
import {
  TextField,
  InputLabel,
} from "@mui/material";
import TransferContext from "../TranferContextProvider.js";
import { notifySuccess, notifyWarning } from "../../../util/Notification.js";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { updateBenefit } from "../quickTransferServices/QuickTransferServices";

const PromptPay = () => {
  const {
    activeStep,
    setActiveStep,
    skipped,
    setSkipped,
    citizenId,
    setUuid,
  } = useContext(TransferContext);

  const [loading, setLoading] = useState(false);
  const [promptPayNumber, setPromptPayNumber] = useState("");

  useEffect(() => {
    if (citizenId) {
      setPromptPayNumber(citizenId);
    }
  }, [citizenId]);

  const handleSubmit = async () => {
    if (promptPayNumber !== '' || citizenId !== '') {
      setLoading(true);
      try {
        // Use the same updateBenefit function but with PromptPay specific parameters
        // For PromptPay, we're only sending the promptPayNumber as cuscfBanknum
        // and using "PromptPay" as the bank name
        const result = await updateBenefit(
          citizenId, 
          "", // No bank account name for PromptPay
          promptPayNumber, 
          "PromptPay" // Use "PromptPay" as the bank name
        );
        
        setUuid(result.message);
        setLoading(false);
        handleNext();
        notifySuccess("บันทึกข้อมูลพร้อมเพย์สำเร็จ");
      } catch (error) {
        setLoading(false);
        notifyWarning("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
      }
    } else {
      notifyWarning("กรุณากรอกเลขที่พร้อมเพย์");
    }
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  return (
    <>
      <div className="border-content">
        <div className="d-flex px-3 pt-3 pb-3">
          กรอกข้อมูลพร้อมเพย์
        </div>
        <hr
          className="mx-2"
          style={{ margin: "0px 0px 15px 0px", border: "solid 1px" }}
        />
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
        <>
          <InputLabel
            htmlFor="promptpay_number"
            className="label"
            style={{ fontWeight: "bold" }}
          >
            เลขที่พร้อมเพย์<span className="text-danger mx-1">*</span>
          </InputLabel>
          <TextField
            InputProps={{ sx: { borderRadius: 16 } }}
            id="promptpay_number"
            type="search"
            className="mb-2 label"
            placeholder="เลขที่พร้อมเพย์"
            variant="outlined"
            value={promptPayNumber || citizenId}
            onChange={(e) => {
              const value = e.target.value;
              // กรองให้กรอกได้เฉพาะตัวเลขและจำกัดให้ไม่เกิน 13 ตัวอักษร
              if (/^\d{0,13}$/.test(value)) {
                setPromptPayNumber(value);
              }
            }}
            size="small"
            fullWidth
          />

          <div
            className="font-size-content-otp"
            style={{
              marginTop: 5,
              color: "red",
              fontSize: "0.8rem",
            }}
          >
            หมายเหตุ : <br />
            บัญชีพร้อมเพย์สำหรับรับเงินผลประโยชน์ ต้องเป็นบัญชีที่ผูกข้อมูล<br />
            ด้วยเลขบัตรประชาชนเท่านั้น
          </div>
        </>
      </div>
      <button
        style={{ fontSize: 15 }}
        onClick={handleSubmit}
        className="btn-checkout-premium w-100 p-2 bold"
      >
        ตกลง
      </button>
      <button
        className="btn-checkout-back w-100 p-2 bold"
        onClick={handleBack}
      >
        กลับ
      </button>
    </>
  );
};

export default PromptPay;